import axios from "./axios";

export const listNodes = async(params) => {
  try {
    const nodes = await axios.get(
      `/api/v1/provision/node`, {params: params}
    );
    return nodes;
  } catch(error) {
    return { status: "error", error };
  }
}

export const getNode = async(name) => {
  try {
    const node = await axios.get(
      `/api/v1/provision/node/${name}`
    );
    return node;
  } catch(error) {
    return { status: "error", error };
  }
}

export const listPods = async(params) => {
  try {
    const pods = await axios.get(
      `/api/v1/provision/pod`, {params:params}
    );
    return pods;
  } catch(error) {
    return { status: "error", error };
  }
}

export const getPod = async(name, namespace) => {
  try {
    const node = await axios.get(
      `/api/v1/provision/pod/${namespace}/${name}`
    );
    return node;
  } catch(error) {
    return { status: "error", error };
  }
}